import _get from 'lodash/get';
import { LAYOUT_ENTITIES, LAYOUT_FRONTSPACES } from '@bedrock/fido-sdk';
import config from '@bedrock-rdk/config';
import { fetchLayout } from '../layout/layout.actions';
import { getRequestedEntityType, getRequestedEntityId, getCurrentLayout } from '../layout/layout.selectors';
import { getSearchDebounceId, getSearchQuery } from './search.selectors';
import { formattingInput } from './search.utils';
import {
  SEARCH_RESULTS,
  SAVE_SEARCHED_ITEM,
  GET_SEARCHED_ITEM,
  UPDATE_SEARCHED_ITEMS,
  SEARCH_DEBOUNCE_MS,
  SEARCH_INPUT,
  MAX_TEXT_LENGTH_TO_SEARCH,
} from './search.constants';
import { sendEvent } from '../analytics/analytics.utils';

export const stopSearch = () => (_, getState) => {
  const timeoutId = getSearchDebounceId(getState());

  clearTimeout(timeoutId);
};

export const searchAll = query => async (dispatch, getState) => {
  const state = getState();
  const entityId = getRequestedEntityId(state);
  const entityType = getRequestedEntityType(state);

  const currentResults = getCurrentLayout(getState());
  const currentQuery = (currentResults.queryParameters && currentResults.queryParameters.query) || '';
  const hasEnoughCharsInCurrentQuery = currentQuery.length >= config.search.charactersToSearch;

  if (query && query.length >= config.search.charactersToSearch) {
    await dispatch(fetchLayout(entityType, entityId, { query: query || '' }));
    const results = getCurrentLayout(getState());
    const { blocks } = results;
    let resultNumber = 0;
    blocks.forEach(item => {
      resultNumber += _get(item, 'content.items.length', 0);
    });
    sendEvent({ key: 'searchInput', input: query, results: resultNumber });
    // In case BFF returned empty layout, we need to fetch default search layout explicitly
    if (results && results.blocks && !results.blocks.length) {
      await dispatch(fetchLayout(LAYOUT_ENTITIES.frontspace, LAYOUT_FRONTSPACES.search));
    }
  } else if (hasEnoughCharsInCurrentQuery) {
    // In this way we are checking if current results are returned from a query or it's a default layout already
    // So when hasEnoughCharsInCurrentQuery is true, it was an actual search result, we need to invalidate,
    // otherwise we will skip a layout request as we already have a default one.
    await dispatch(fetchLayout(LAYOUT_ENTITIES.frontspace, LAYOUT_FRONTSPACES.search, { query: '' }));
  }

  dispatch({
    type: SEARCH_RESULTS,
    query,
  });
};

export const searchKeyInput = symbol => (dispatch, getState) => {
  const state = getState();
  const query = formattingInput(symbol, getSearchQuery(state) || '');

  if (query.length >= MAX_TEXT_LENGTH_TO_SEARCH) {
    return;
  }

  dispatch(stopSearch());

  const debounceId = setTimeout(() => {
    dispatch(searchAll(query));
  }, SEARCH_DEBOUNCE_MS);

  dispatch({
    type: SEARCH_INPUT,
    debounceId,
    query,
  });
};

export const saveSearchedItem = searchedItem => dispatch => {
  // NOTE: this event remove from tagging plan in accordance to comment in STB-56
  // const currentResults = getCurrentLayout(getState());
  // const currentQuery = (currentResults.queryParameters && currentResults.queryParameters.query) || '';
  // sendEvent({ key: 'searchResult', id: searchedItem.id, name: searchedItem.title, input: currentQuery });

  // NOTE: this action is always invoked when a search results item is selected.
  // Hence, we are using it for analytics reporting as it has full Redux access.
  dispatch({
    searchedItem,
    type: SAVE_SEARCHED_ITEM,
  });
};

export const getSearchedItems = () => ({
  type: GET_SEARCHED_ITEM,
});

export const updateSearchedItems = searchedItems => ({
  searchedItems,
  type: UPDATE_SEARCHED_ITEMS,
});
